import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {exportToExcel} from "../utils/reports/exportToExcel";
import {formatDate} from "../utils/dates";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";

function Grillabowallet (props){
    const fileInputRef = useRef();
    const searchInput = useRef(null);
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosExport, setDatosExport] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [casinos, setCasinos] = useState([])
    const [casinoSeleccionado, setCasinoSeleccionado] = useState()
    const [saldo, setSaldo] = useState()
    const [idcasino, setIdCasino] = useState()
    const [nombrecasino, setNombreCasino] = useState()
    const [direccioncasino, setDireccionCasino] = useState()
    const [valorticketcasino, setValorTicketCasino] = useState()
    const [empresacasino, setEmpresaCasino] = useState()
    const [rut, setRut] = useState()
    const [rut2, setRut2] = useState('')
    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [beneficiariobyuser, setBeneficiariobyuser] = useState([])
    const [selectBeneficiarios, setSelectBeneficiarios] = useState()
    const [beneficiario, setBeneficiario] = useState()
    const [ticketid, setTicketId] = useState()
    const [user, setUser] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    
    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')    
    const [alert1, setAlert1] = useState(false);

    const [tituloAlert3, setTituloAlert3] = useState('')
    const [textoAlert3, setTextoAlert3] = useState('')
    const [claseAlert3, setClaseAlert3] = useState('')    
    const [alert3, setAlert3] = useState(false);

    const [fechainicio, setFechaInicio] = useState('')
    const [fechafinal, setFechaFinal] = useState('')
    const [file, setFile] = useState('');
    const [fileName, setFileName] = useState("");
    const [barcode, setBarCode] = useState('')
    const [barcoderest, setBarcoderest] = useState('')
    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   

    let statuscall = '' 
    
    const dataListCasinos = casinos.map((item, i) => (
        <option key={i} value={item.id}>{item.nombre}</option>
    ));

    const dataList = datos.map((item, i) => 
    <div key={i} className="bg-gray-200 p-6 rounded-lg shadow-md mt-6">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalles del apoderado</h3>
    
    {/* Contenedor con grid de 4 columnas, en pantallas grandes */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
    
    {/* Columna 1 */}
    <div className="space-y-2">
        {/* Número de Índice - destacado */}
        <div className="flex justify-end">
        <span className="bg-indigo-600 text-white px-3 py-1 rounded-lg text-xl font-bold">{i + 1}</span>
        </div>

        {/* RUT Cliente */}
        <div className="flex justify-end">
        <span className="font-medium text-gray-500">Mail:</span>
        <span className="font-semibold text-gray-800">{item.mail}</span>
        </div>
    </div>

    {/* Columna 2 */}
    <div className="space-y-2">
        {/* Nombre Cliente */}
        <div className="flex justify-end">
        <span className="font-medium text-gray-500">Nombre Apoderado:</span>
        <span className="font-semibold text-gray-800">{item.nombre}</span>
        </div>

        {/* RUT Beneficiario */}
        <div className="flex justify-end">
        <span className="font-medium text-gray-500">RUT Apoderado :</span>
        <span className="font-semibold text-gray-800">{item.rut}</span>
        </div>
    </div>

    {/* Columna 3 */}
    <div className="space-y-2">
        {/* Valor Ticket */}
        <div className="flex justify-end">
        <span className="font-medium text-gray-500">Casino:</span>
        <span className="font-semibold text-gray-800">{item.casino}</span>
        </div>
    </div>

    {/* Columna 4 */}
    <div className="space-y-2">
        <div className="flex justify-end">
           <button 
            className="bg-indigo-600 
                        text-white 
                        px-4 py-2 
                        rounded-lg 
                        shadow-md 
                        hover:bg-indigo-700 
                        focus:outline-none 
                        focus:ring-2 
                        focus:ring-indigo-500" 
                onClick={() => clickSaldo(item)}>Agregar Saldo</button>
        </div>
    </div>
    </div>
    </div>);

    const handleChangeCasino = (event) => {
        setCasinoSeleccionado(event.target.value);
    };

    const handleSaldo= (event) => {
        setSaldo(event.target.value)
    }
    
    const handleExport = () => {
        
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETLISTAREXCEL, {
            params: {
                casino: idcasino.replace('"', ''),
                fecha_inicio: fechainicio, 
                fecha_fin: fechafinal
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosExport(response.data.tickets)
        }).catch(error => {
            return error     
        });

        const formattedData = datosExport.map((tickets) => ({
            Rut_apoderado: tickets.rutcliente,
            Mail_apoderado: tickets.mail,
            Nombre_apoderado: tickets.nombre,
            Apellido_apoderado: tickets.apellido,
            Rut_beneficiario: tickets.rutbeneficiario,
            Valor_ticket: tickets.valor,
            Estado_pago: tickets.estadopago,
            Estado_consumo: tickets.estadoconsumo,
            Nombre_Casino: tickets.nombrecasino,
            Ticket_id: tickets.ticket_id
        }))
        exportToExcel(formattedData, `ReporteTickets_${formatDate()}.xlsx`, "Tickets");
    };    

    const handleKeyDown = (event) => {
        if (event.keyCode === 13)
        {
            setBarCode(event.value)
        }
    }

    const consumirTicket = (e) => {
        if(barcoderest != '')
        {
            let idtrim = barcoderest.trim()
            let id = idtrim.substring(16, idtrim.length)
            Axios.get(process.env.REACT_APP_URLTICKETSCANN, {
                params: {
                    id: id 
                }, 
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }
            }).then((response) => {
    
                if(response.data.MessageCode === '0')
                {
                    setTituloAlert3('Consumo por scanner')
                    setTextoAlert3('Ticket Consumido')
                    setClaseAlert3('success')
                    setBarCode('')
                    setAlert3(true)
                    searchInput.current.focus()
                    setTimeout(() => {    
                        setAlert3(false)
                    }, 3000)
                }
                else
                {
                    setTituloAlert3('Consumo por scanner')
                    setTextoAlert3('Ticket Ya Consumido o no Existente')
                    setClaseAlert3('warning')
                    setBarCode('')
                    setAlert3(true)
                    searchInput.current.focus()
                    setTimeout(() => {    
                        setAlert3(false)
                    }, 3000)
                }
            }).catch(error => {
                return error     
            });
        }
        else
        {
            setTituloAlert3('Consumo por scanner')
            setTextoAlert3('Debe scannear el codigo primero')
            setClaseAlert3('warning')
            setAlert3(true)
            setTimeout(() => {    
                setAlert3(false)
            }, 3000)
        }

    }

    const handleBeneficiario = async (e) =>{
        setBeneficiario(e.target.value)
    }

    const handleRut = async (e) =>{
        setRut(e.target.value)
    }    

    const handleRut2 = async (e) =>{
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
                
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
                
        // Formatear RUN
        setRut2(cuerpo + '-'+ dv)
        setVisible('seccionNoVisible')
    }

    const handleFecha = async (e) =>{
        setFecha(e.target.value)
        setVisible('seccionNoVisible')
    } 
    
    const handleBarcode = async (e) =>{
        setBarcoderest(e.target.value)
    }

    const putCasino = async () =>{
        let urlput = process.env.REACT_APP_URLPUTCASINO+idcasino.toString()+'/update'
        let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
        const data = {   
            direccion: direccioncasino,
            value_ticket: valorticketcasino,
        };

        const casinoPut = await Axios.put(urlput, data, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
        }}).then(res => statuscall = res).catch(err => statuscall = err.response);
            
        if(statuscall.status == 200)
        {   
            handleGrillaCasino()
            handleClose()
        }
    }

    const handleGrillaCasino = async () =>{
        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data)
            setDatosBackup(response.data)
        }).catch(error => {
            return error     
        });
    }

    const agregarSaldo = async () =>{
        if(saldo > 0)
        {
            const data = {   
                user_id: user,
                saldo: saldo,
            };
            const res = await Axios.post(process.env.REACT_APP_URLUSERWALLETUSERASIGNARSALDO, data,{
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
            }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                        
            if (statuscall.data.MessageCode == "0")
            {
                GetUsers()
                GetCasinos()    
                setTituloAlert('Agregar Saldo')
                setTextoAlert(statuscall.data.Message)
                setClaseAlert('success')
                setAlert(true)
                setSaldo("")
                setTimeout(() => {    
                    setAlert(false)
                    handleClose()
                }, 3000)
            }

        }
        else
        {
            setTituloAlert('Agregar saldo')
            setTextoAlert('Debe insertar un valor mayor a 0')
            setClaseAlert('warning')
            setAlert(true)
            setTimeout(() => {    
                setAlert(false)
            }, 3000)
            
        }
    }

    const handlePageSize = (e) => {
        setPageSize(e.target.value)
    }

    const listBeneficiarios = beneficiariobyuser.map((item, i) =>
        <option key={i} value={item.id}>{item.primer_nombre} {item.primer_apellido}</option>
    )

    const GetUsers = () =>
    {
        Axios.get(process.env.REACT_APP_URLUSERWALLETLISTAR, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                casino_id: casinoSeleccionado
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.users)
            setDatosBackup(response.data.users)

            setCurrentPage(response.data.users_metadata.currentPage)
            setPageNumber(response.data.users_metadata.currentPage)
            setTotalPages(response.data.users_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }

    const GetCasinos = () =>{
        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            console.log("Casinos" + response.data)
            setCasinos(response.data)
        }).catch(error => {
            return error     
        });  
    }


    useEffect(() => {
        GetUsers()
        GetCasinos()
        window.addEventListener('keydown', handleKeyDown);
        // cleanup this component
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }        
    }, [pageNumber]);

    const clickSaldo= (item) =>{
        //Setea estados para agregar saldo
        setUser(item.mail)
        handleShow()
    }

    const handleClose = () => {
        setRut('')
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataRutcliente = item.rutcliente
                const itemDataRutBeneficiario = item.rutbeneficiario
                const itemDatanombre =  (item.nombre ?? '').toUpperCase(); 
                const itemDataapellido = (item.apellido ?? '').toUpperCase()
                const itemDataestadopago = (item.estadopago ?? '').toUpperCase()
                const itemDataestadoconsumo = (item.estadoconsumo ?? '').toUpperCase()
                const itemDatavalor = item.valor
                const campo = itemDatanombre +" "+ itemDataapellido +" "+ itemDataRutcliente+" "+itemDataRutBeneficiario +" "+itemDataestadopago+" "+itemDataestadoconsumo+" "+itemDatavalor
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
    }

    const handleFechaInicio = (e) => {
        setFechaInicio(e.target.value)
    }

    const handleFechaFinal = (e) => {
        setFechaFinal(e.target.value)
    }

    const saveFile = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    }
 
    const uploadFile = async (e) => {
        if(file != '')
        {
            let idcasinoappstr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
            let casino_id = idcasinoappstr.replace('"', '')
            const formData = new FormData();
            formData.append("file", file);
            formData.append("fileName", fileName);
            formData.append("casino_id", casino_id);
        
            try {
              const res = await Axios.post(
                process.env.REACT_APP_URLTICKETPROCESOMASIVO,
                formData
              )
              
              if(res.data.MessageCode == "0")
              {
                fileInputRef.current.value = null  
                setFile('')
                setFileName('')
                setTituloAlert1('Consumo masivo de tickets')
                setTextoAlert1('Archivo Cargado y Procesado Correctamente')
                setClaseAlert1('success')
                setAlert1(true)
                setTimeout(() => {    
                    setAlert1(false)
                }, 3000)
              }
              else
              {
                fileInputRef.current.value = null  
              }
            } catch (ex) {
              console.log(ex);
            }
        }
        else
        {
            setTituloAlert1('Consumo masivo de tickets')
            setTextoAlert1('Debe seleccionar un archivo')
            setClaseAlert1('warning')
            setAlert1(true)
            setTimeout(() => {    
                setAlert1(false)
            }, 3000)
        }
    }


    return(
    <div className='w-full'>
        
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6  mx-4 mb-2">
            <h2 className="text-xl font-semibold mb-4">Filtros Admin Wallet</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                {/* Campo Fecha Inicio */}
                <div className="flex flex-col">
                    <label htmlFor="fechaInicio" className="text-sm font-medium text-gray-600 mb-1">Seleccione casino</label>
                    <select
                        id="opciones"
                        value={casinoSeleccionado}
                        onChange={handleChangeCasino}
                        className="text-sm font-medium text-gray-600 mb-1 border border-gray-300 rounded px-3 py-2"
                        >
                        <option value="">-- Seleccionar --</option>
                        {dataListCasinos}
                    </select>
                </div>

                {/* Campo Selección Número de Páginas */}
                <div className="flex flex-col">
                    <label htmlFor="numeroPaginas" className="text-sm font-medium text-gray-600 mb-1">Número de Páginas</label>
                    <input 
                    type="number" 
                    id="numeroPaginas"
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Botón Generar Reporte con Icono */}
                <div className="flex flex-col justify-end w-full sm:w-auto">
                <button onClick={GetUsers} className="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2">
                    {/* Icono de Reporte */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h2M15 3h-6a2 2 0 0 0-2 2v4h10V5a2 2 0 0 0-2-2z" />
                    </svg>
                    {/* Texto del Botón */}
                    Consultar apoderados
                </button>
                </div>

                </div>
            </div>

        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4  mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="flex justify-between items-center mb-4">
                        {/* Campo de Búsqueda */}
                        <div className="flex flex-col col-span-1 sm:col-span-2 lg:col-span-1">
                            
                            <div className="flex items-center bg-gray-100 border border-gray-300 rounded-lg">
                            <input 
                                type="search" 
                                id="search"
                                onChange={handleChangeList} 
                                placeholder="Buscar en grilla" 
                                className="p-2 text-sm bg-transparent border-0 outline-none flex-1 rounded-l-lg focus:ring-0" 
                            />
                            <button className="p-2 text-gray-500 bg-transparent rounded-r-lg hover:bg-gray-200">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0 0l5 5" />
                                </svg>
                            </button>

                            </div>
                        </div>

            </div>
            <div className="overflow-y-auto h-[600px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    {dataList}
                </div>
            </div>
            <div className="w-full mt-4 flex justify-center">
                    <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>
            </div>
        </div>


        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Agregar Saldo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>

                <div className="space-y-6">
                    {/* Rut Cliente */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Ingrese el monto</label>
                        <div className="col-span-2">
                        <input
                            type="number"
                            value={saldo}
                            onChange={handleSaldo}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>


                </div>

            </Modal.Body>
            <Modal.Footer>
            <button
                onClick={handleClose}
                className="bg-red-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                >
                Cerrar
            </button>

            <button
                onClick={agregarSaldo}
                className="bg-indigo-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                Agregar
            </button>

            </Modal.Footer>
            <Modal.Footer className={visible}>
            <div>
                <h4>Debe completar todos los campos</h4>
            </div>
            </Modal.Footer>
        </Modal>                                                                                                                                                                                           
    </div>    
    )
}
export default Grillabowallet